import { ActionReducer } from '@ngrx/store';

import { Actions, ActionTypes } from './recipes.actions';
import { RecipesInterface as Recipes } from './recipes.models';
import { tassign } from '../../tools';

/**
 * Please do not modify the store directly. Always use reducers.
 */

export const initialRecipesState: Recipes = {
	items: [],
	selected: null,
	lastUpdated: null,
	isLoading: false,
	// Refactor
	groups: [],
	itemsVisible: [],
	itemsAll: {},
};

/**
 * Reduce the store.
 * @param {Recipes} state - the current state
 * @return {Recipes} The new state
 */
export const recipes: ActionReducer<any, Actions> = (state: Recipes = initialRecipesState, action: Actions): Recipes => {
	switch (action.type) {

		case ActionTypes.LOAD_RECIPES:
			return action.payload;

		case ActionTypes.RESET_STATE:
			return initialRecipesState;

		case ActionTypes.SET_SELECTED:
			return tassign(state, {
				selected: action.payload
			});

		case ActionTypes.ADD_AVAILABILITY:
			return tassign(state, {
				itemsAll: tassign({}, state.itemsAll, {
					[action.payload.date]: action.payload.items,
				}),
			});

		// @TODO unit test
		case ActionTypes.SET_FILTERED_RECIPES:
			return tassign(state, {
				itemsVisible: action.payload
			});

		case ActionTypes.SET_IS_LOADING:
			return tassign(state, {
				isLoading: action.payload
			});
	}
	return state;
};
